import { render, staticRenderFns } from "./DefaultHeaderDropdownMssgs.vue?vue&type=template&id=04506b3d&"
import script from "./DefaultHeaderDropdownMssgs.vue?vue&type=script&lang=js&"
export * from "./DefaultHeaderDropdownMssgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports